// react import
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import CommonCell from "../../common/CommonCell";
import { userColors } from "../../util/colors";
import DavinciSelectBoard from "./DavinciSelectBoard";
import CommonBackground from "../../common/CommonBackground";

// step = 0 최초에 턴을 넘어왔을때, 뽑을 타일과 위치를 선택, 확정을 누르면 step 1로 넘어감. (카드가 없다면 바로 step 1로 이동)
// 놓을수 있는 위치에 마우스 호버 시에 반투명하게 선 표시 조커일 경우 => 아무곳이나 놓을수 있고 놓는 순간
// step = 1 추리할 타일 선택, 뽑아온 카드는 (drawCard 별도 변수 추가) 아래로 약간 튀어 나와 있음, 선택 시에 selectCard 변수가 update되어 다른 사람도 볼 수 있음.
// 맞춘 경우에 step =>2 로 이동, 틀린 경우에 drawCard가 open, drawCard가 없는 경우 step => 3로 이동
// step = 2 맞춘 경우에 추가로 추리할지, 턴을 넘길지 선택,
// step = 3 틀렸고,  드로우 카드가 없어서 오픈할 카드 선택
// step = 4 게임 엔드,

// step = 0 최초의 턴, 무조건 선택 후에 제출을 해야 함 성공시 해당 카드 밝혀짐
// step = 1 선택 성공, 턴 종료 버튼 생성, 턴을 종료하거나 추가 제출이 가능함.
// step = 2 선택 실패, 본인의 카드를 선택하면 밝혀지면서 턴이 넘어감
// end 판별 순간에 남은 사람이 1명일 경우 step을 3으로
// step = 3 게임 종료
const DavinciGameBoard = () => {
  const {
    davinciCode: { davinciCodeUsers, turnUser, turnStep, gameStatus },
  } = useSelector(state => state.GameSlice);
  const noticeObject = {
    0: "타일의 위치를 선택하세요.",
    1: "다른 사람의 타일을 추리하세요.",
    2: "정답입니다! 턴을 넘기거나, 추리를 계속하세요.",
    3: "틀렸습니다! 타일을 공개하고 다음 턴으로 넘어갑니다.",
    4: "게임이 종료되었습니다!",
  };

  const { userId } = useSelector(state => state.LoginInfoSlice);

  // 제출과 셀프 오픈에 end 판별 로직 추가

  return (
    <Wrap>
      <UserContainer>
        <CommonBackground column={16} />
        {davinciCodeUsers.map((item, index) => (
          <UserBoard user={item} key={`${index}davinciUserBoardKey`} />
        ))}
      </UserContainer>

      <SelectArea>
        {turnUser?.userId === userId && <DavinciSelectBoard />}
      </SelectArea>
      <NoticeBar>{gameStatus && noticeObject[turnStep]}</NoticeBar>
    </Wrap>
  );
};

export default DavinciGameBoard;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  border-left: 1px solid #e0e0e0;
`;

const UserBoard = ({ user }) => {
  const { userId } = useSelector(state => state.LoginInfoSlice);
  const {
    users,
    roomId,
    davinciCode: { drawCard, turnUser, turnStep, selectCard },
  } = useSelector(state => state.GameSlice);

  const cards = [...user?.cards].sort((a, b) => {
    return a?.locationIndex - b?.locationIndex;
    // if (a.value !== b.value) {
    //   return a.value - b.value;
    // } else {
    //   if (a.color === "B" && b.color === "W") {
    //     return -1;
    //   } else if (a.color === "W" && b.color === "B") {
    //     return 1;
    //   }
    // }
    // return null;
  });
  const checkTurn = turnUser.userId === user.userId;

  return (
    <UserBoardWrap>
      <RowContainer>
        {[1, 2, 3, 4, 5].map((item, index) => {
          const findUser = users.find(i => i?.userId === user?.userId);
          const userColor = userColors[findUser?.order];

          const checkIndex = index === 0;
          return (
            <CommonCell
              key={`${item}${user?.userID}davinciCodeTopRowKey`}
              styles={{
                background:
                  checkIndex &&
                  `linear-gradient(135deg, ${userColor} 5px, ${
                    checkTurn ? "#E7F1EC" : "#fff"
                  } 0)`,
                border: checkTurn && checkIndex && "1px solid #107C41",
                // backgroundColor: checkTurn && checkIndex && "#E7F1EC",
                minWidth: "20%",
                height: "100%",
              }}>
              {checkIndex ? user?.nickname : ""}
            </CommonCell>
          );
        })}
      </RowContainer>
      <CardContainer $checkSelf={user.userId === userId} $checkEnd={user?.end}>
        {cards.map((cardItem, cardIndex) => {
          const checkReveal = user?.userId === userId || cardItem.reveal;
          const checkDraw =
            drawCard.label === cardItem.label &&
            drawCard.color === cardItem.color;
          const checkSelect =
            selectCard.label === cardItem.label &&
            selectCard.color === cardItem.color;
          // 카드 클릭 이벤트는 무조건 내 턴일때만

          // step = 0 최초에 턴을 넘어왔을때, 뽑을 타일과 위치를 선택, 확정을 누르면 step 1로 넘어감. (카드가 없다면 바로 step 1로 이동)
          // 놓을수 있는 위치에 마우스 호버 시에 반투명하게 선 표시 조커일 경우 => 아무곳이나 놓을수 있고 놓는 순간
          // step = 1 추리할 타일 선택, 뽑아온 카드는 (drawCard 별도 변수 추가) 아래로 약간 튀어 나와 있음, 선택 시에 selectCard 변수가 update되어 다른 사람도 볼 수 있음.
          // 맞춘 경우에 step =>2 로 이동, 틀린 경우에 drawCard가 open, drawCard가 없는 경우 step => 3로 이동
          // step = 2 맞춘 경우에 추가로 추리할지, 턴을 넘길지 선택,
          // step = 3 틀렸고,  드로우 카드가 없어서 오픈할 카드 선택
          // step = 4 게임 엔드,

          const ClickCard = async () => {
            const checkMyTurn = userId === turnUser.userId;
            const cardReveal = cardItem.reveal;
            const checkCardOwn = user?.userId === userId;
            const docRef = doc(db, "game", `room${roomId}`);

            if (checkMyTurn) {
              if (turnStep === 1 || turnStep === 2) {
                // 추리일때 =>
                // 내가 상대방의 카드를 클릭하는 상황 => 내 브라우저에서 내 턴이고,
                // 내가 누르는 카드는 내 카드가 아니고, 밝혀진 카드가 아니여야함
                // 누르는 건 1번,2번 스텝만.
                if (!checkCardOwn && !cardReveal) {
                  await updateDoc(docRef, {
                    "davinciCode.selectCard": checkSelect ? {} : cardItem,
                  });
                }
              }
            }
          };

          return (
            <DavinciCard
              style={{
                translate: checkDraw && "0 40%",
                border: cardItem.reveal && "1px solid #FF3333",
              }}
              $color={cardItem.color}
              key={`${cardItem.color}${cardItem.value}DavinchCardkey`}
              onClick={ClickCard}>
              {checkReveal || turnStep === 4 ? cardItem.label : ""}
              {checkSelect && <SelectLine />}
            </DavinciCard>
          );
        })}
      </CardContainer>
      <RowContainer>
        {[1, 2, 3, 4, 5].map((item, index) => (
          <CommonCell
            styles={{
              minWidth: "20%",
              height: "100%",
            }}
            key={`${item}${user?.userID}davinciCodeBottomRowKey`}
          />
        ))}
      </RowContainer>
    </UserBoardWrap>
  );
};

const UserBoardWrap = styled.div`
  width: 100%;
  min-height: 25%;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;
const RowContainer = styled.div`
  width: 100%;
  min-height: 25%;
  display: flex;
`;

const UserContainer = styled.div`
  width: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
`;

const CardContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 50%;
  background-color: ${({ $checkSelf, $checkEnd }) =>
    $checkEnd ? "#f5f5f5" : $checkSelf ? "#FFFAE0" : "#fff"};
  border-right: 1px solid #e0e0e0;

  gap: 1px;
  border-bottom: 1px solid #e0e0e0;
`;

export const DavinciCard = styled.div`
  width: ${({ $width }) => $width || "5%"};
  height: ${({ $height }) => $height || "45%"};
  border: 1px solid #8a8a8a;
  background-color: ${({ $color }) => ($color === "B" ? "#D1D1D1" : "#fff")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  position: relative;
  cursor: pointer;
`;

const SelectLine = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  outline: 1px solid #137e43;
  border: 2px solid #107c4180;
`;

const SelectArea = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  background-color: #fff;
  border-right: 1px solid #e0e0e0;

  font-size: 12px;
  padding: 0 8px;
`;

const NoticeBar = styled.div`
  width: 100%;
  min-height: 21px;
  color: #242424;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
`;

// step이 2이고 카드가 나의 카드고, 접속한 유저가 현재 턴인 유저일 경우 pointer
// step이 2이고 카드가 나의 카드가 아닐경우 no Pointer
